const faFileExport = {
  prefix: 'fal',
  iconName: 'file-export',
  icon: [
    576,
    512,
    ['arrow-right-from-file'],
    'f56e',
    'M224 32L96 32C78.3 32 64 46.3 64 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-48 32 0 0 48c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64L32 64C32 28.7 60.7 0 96 0L229.5 0c17 0 33.3 6.7 45.3 18.7L397.3 141.3c12 12 18.7 28.3 18.7 45.3l0 85.5-32 0 0-80-96 0c-35.3 0-64-28.7-64-64l0-96zm48 288l241.4 0-44.7-44.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l72 72c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L513.4 352 272 352c-8.8 0-16-7.2-16-16s7.2-16 16-16zm98.7-160L256 45.3 256 128c0 17.7 14.3 32 32 32l82.7 0z',
  ],
};
export default faFileExport;
